import { InteractionStatus, InteractionType } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

import { DEFAULT_INTERACTION_TYPE } from "../azure-auth.const";
import { getLoginFunctionName, getLogoutFunctionName } from "../azure-auth.types";

/**
 * Custom hook that provides the Azure Active Directory authentication context and methods for interacting with the
 * Azure Active Directory client.
 * @param options The options for the Azure Active Directory authentication context.
 * @returns The Azure Active Directory authentication instance, context and methods.
 */
export function useAzureAuth(options?: { interactionType?: InteractionType }) {
    const { interactionType = DEFAULT_INTERACTION_TYPE } = options ?? {};

    const { instance, accounts, inProgress: interactionStatus } = useMsal();
    const user = accounts.at(0);

    const isInteractionInProgress = interactionStatus !== InteractionStatus.None;

    const triggerLogin = () => {
        const loginFunctionName = getLoginFunctionName(interactionType);
        return instance[loginFunctionName]();
    };

    const triggerLogout = () => {
        const logoutFunctionName = getLogoutFunctionName(interactionType);
        instance.setActiveAccount(null);
        return instance[logoutFunctionName]();
    };

    return { instance, user, isInteractionInProgress, triggerLogin, triggerLogout };
}
